// @import

import { ensureHTMLElement } from "@src/js/lib/ensure";
import { viewport } from "@src/js/lib/viewport";
import Alpine from "alpinejs";
import EmblaCarousel from "embla-carousel";

Alpine.directive("bento-cards", (element, {}, { cleanup, effect }) => {
  const OPTIONS = { align: "start", inViewThreshold: 0.1, loop: true } as const;

  const viewportNode = ensureHTMLElement(element.querySelector(".c-bento-cards__viewport"));

  let slider: ReturnType<typeof EmblaCarousel> | null = null;

  effect(() => {
    if (viewport.width < 1024) {
      initSlider();
    } else {
      destroySlider();
    }
  });

  function destroySlider() {
    if (slider) {
      slider.destroy();
      slider = null;
    }
  }

  function initSlider() {
    if (!slider) {
      slider = EmblaCarousel(viewportNode, OPTIONS);
    }
  }

  cleanup(() => {
    destroySlider();
  });
});
